import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Response, Signature } from '@ui/src';
import { signatureTransationApi } from './service';
import { MfaToken } from '../types';

export interface SignaturesState {
  signatures?: Signature[];
  mfaToken?: string;
}

const initialState: SignaturesState = {
  signatures: undefined,
};

export const signatures = createSlice({
  name: 'statuses',
  initialState,
  reducers: {
    clearSignaturesState: (state) => {
      state.signatures = undefined;
      state.mfaToken = undefined;
    },
    clearMfaToken: (state) => {
      state.mfaToken = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      signatureTransationApi.endpoints.getTransactionSignature.matchFulfilled,
      (state, action: PayloadAction<Response<Signature>>) => {
        state.signatures = action.payload.data.edges.map((item) => item.node);
      },
    );
    builder.addMatcher(
      signatureTransationApi.endpoints.sendCode.matchFulfilled,
      (state, action: PayloadAction<{ data: MfaToken }>) => {
        state.mfaToken = action.payload.data.token;
      },
    );
    builder.addMatcher(
      signatureTransationApi.endpoints.validateCode.matchRejected,
      // @ts-ignore
      (
        state,
        action: {
          meta: {
            baseQueryMeta: {
              response: {
                headers: Headers;
              };
            };
          };
        },
      ) => {
        if (
          action.meta.baseQueryMeta.response.headers.get(
            'x-baseella-next-mfa-token',
          )
        ) {
          state.mfaToken = action.meta.baseQueryMeta.response.headers.get(
            'x-baseella-next-mfa-token',
          ) as string;
        }
      },
    );
  },
});

export const { clearSignaturesState, clearMfaToken } = signatures.actions;

export default signatures.reducer;
